import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

export interface AiCoinPack {
  id: string;
  name: string;
  coins: number;
  priceGbp: number;
}

export const DEFAULT_AI_COIN_PACKS: AiCoinPack[] = [
  { id: "try", name: "Top-up Try", coins: 20, priceGbp: 4.99 },
  { id: "creator", name: "Top-up Creator", coins: 70, priceGbp: 14.99 },
  { id: "studio", name: "Top-up Studio", coins: 200, priceGbp: 39.99 },
];

export interface AiCoinBalance {
  userEmail: string;
  planAllowanceRemaining: number;
  topUpBalance: number;
  reservedFromPlan: number;
  reservedFromTopUp: number;
  allowancePeriod?: string;
  availablePlanCoins: number;
  availableTopUpCoins: number;
  totalAvailable: number;
  packs: AiCoinPack[];
}

export interface AiCoinQuote {
  mode: string;
  required: number;
  planCoinsUsed: number;
  topUpCoinsUsed: number;
  available: number;
  availablePlanCoins: number;
  availableTopUpCoins: number;
  sufficient: boolean;
  shortfall: number;
  breakdown: string;
}

export interface AiCoinTransaction {
  userEmail: string;
  type: string;
  bucket: string;
  amount: number;
  jobId?: string;
  packId?: string;
  paypalOrderId?: string;
  note?: string;
  createdUtc: string;
}

@Injectable({ providedIn: "root" })
export class AiCoinService {
  private readonly base = environment.apiBaseUrl + "api/AiCoins";

  constructor(private http: HttpClient) {}

  getBalance(): Observable<AiCoinBalance> {
    return this.http.get<AiCoinBalance>(`${this.base}/balance`);
  }

  getQuote(mode: string, durationSec?: number, stepCount?: number): Observable<AiCoinQuote> {
    const query: string[] = [`mode=${encodeURIComponent(mode)}`];
    if (durationSec && durationSec > 0) query.push(`durationSec=${durationSec}`);
    if (stepCount && stepCount > 0) query.push(`stepCount=${stepCount}`);
    return this.http.get<AiCoinQuote>(`${this.base}/quote?${query.join("&")}`);
  }

  getHistory(take: number = 50): Observable<AiCoinTransaction[]> {
    return this.http.get<AiCoinTransaction[]>(`${this.base}/history?take=${take}`);
  }

  purchase(packId: string, paypalOrderId: string): Observable<AiCoinBalance> {
    return this.http.post<AiCoinBalance>(`${this.base}/purchase`, { packId, paypalOrderId });
  }
}
